import React from 'react'
import { useData } from '../DataProvider'
import { Box } from '@mui/joy'
import Step3Default from './Step3Default'
import Step3Retirement from './Step3Retirement'
import Step3WorkingForMyself from './Step3WorkingForMyself'
import { NavButton, ButtonContainer } from '../Buttons'
import useTranslation from '../../shared/TranslationProvider'
import StepProgressHeading from '../StepProgressHeading'
import { stepDescribedBy } from '../stepProgress'

const Step3 = () => {
  const {
    setCurrentStep,
    interestIsRetirement,
    interestIsWorkingForSelf,
    interestIsJobSeeking,
    step,
  } = useData()
  const { t } = useTranslation()
  const subtitleId = 'onboarding-step3-subtitle'

  return (
    <>
      <Box className="pt-10" data-testid="a11y-onboarding--step-3">
        {/* CTS-9266 — YNS-020: one h1 per step */}
        <h1
          data-onboarding-step-heading
          tabIndex={-1}
          aria-describedby={stepDescribedBy(subtitleId)}
          className="text-2xl font-bold focus:outline-none md:text-4xl"
        >
          {t('step3.title')}
        </h1>
        <StepProgressHeading>
          {t('stepper_progress', { current: step })}
        </StepProgressHeading>
        <p id={subtitleId} className="py-4 text-base md:text-xl">
          {t('step3.subtitle')}
        </p>
        <div className="flex grid grid-cols-1 flex-col gap-4 pt-2 md:grid-cols-2">
          {interestIsRetirement && <Step3Retirement />}
          {interestIsWorkingForSelf && <Step3WorkingForMyself />}
          {interestIsJobSeeking && <Step3Default />}
        </div>
      </Box>
      <ButtonContainer>
        <NavButton type="back" onClick={() => setCurrentStep(2)}>
          {t('back')}
        </NavButton>
        <NavButton type="submit" onClick={() => setCurrentStep(4)}>
          {t('next')}
        </NavButton>
      </ButtonContainer>
    </>
  )
}
export default Step3
